import { Component, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ProcessedSequenceItemFormComponent } from '@app/components/forms/processed-sequence-item/form.component';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { ProcessedSequenceItem, ProcessedSequenceItemCreate } from '@app/models/processed-sequence-item.interface';
import { ProcessedSequenceItemHelperService } from '@app/services/helpers/processed-sequence-item-helper.service';
import { ToastService } from '@app/services/toast.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-processed-sequence-item-edit',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        ProcessedSequenceItemFormComponent,
        FontAwesomeModule,
        RouterModule,
    ],
    templateUrl: './edit.page.html',
    styleUrl: './edit.page.scss'
})
export class ProcessedSequenceItemEditPage {
  public title = 'Processed Sequence Item Edit';
  formValid = signal(false);
  formValue = signal<ProcessedSequenceItemCreate | null>(null);
  id: number;
  processedSequenceItem$: Observable<ProcessedSequenceItem>;

  faSave = faSave;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private processedSequenceItemHelper: ProcessedSequenceItemHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.processedSequenceItem$ = this.processedSequenceItemHelper.getById(this.id);
  }

  update() {
    let val = this.formValue();
    if(val)
      this.processedSequenceItemHelper.update(this.id, val).subscribe({
        next: (success) => { this.router.navigate(['processed-sequence-items', this.id]); },
        error: (err: AppHttpError) => {
          this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
        }
      });
  }
}
